<template>
  <v-container
    grid-list-lg
  >
    <v-layout
      v-if="componentLoading"
      row
      wrap
      justify-center
    >
      <v-progress-circular
        :size="64"
        :width="3"
        indeterminate
        color="primary"
      />
    </v-layout>
    <v-layout
      v-else
      row
      wrap
      justify-center
    >
      <v-flex class="max-maxWidth">
        <v-card
          id="inviteSettingsContent"
          class="max-shadow"
        >
          <v-card-text>
            <v-container
              grid-list-lg
              fluid
              class="pa-2"
            >
              <v-layout
                column
              >
                <toggle
                  v-model="invitesSettings.shouldFillRequiredFields"
                  class="pt-3"
                  title="Should visitor fill checkin fields"
                  caption="if enabled, visitor has to fill all the required checkin fields"
                />
                <toggle
                  v-model="invitesSettings.shouldSignAgreement"
                  class="pt-3"
                  title="Should visitor sign agreement"
                  caption="if enabled, visitors should sign the NDA agreement"
                />
                <toggle
                  v-model="invitesSettings.shouldTakePhoto"
                  class="pt-3"
                  title="Should take visitor's photo"
                  caption="if enabled, visitor will be asked to take a photo of them"
                />
                <toggle
                  v-model="invitesSettings.shouldExpire"
                  class="pt-3"
                  title="Should invite expire"
                  caption="if enabled, invitations will have expiry date and time"
                />
                <template
                  v-if="invitesSettings.shouldExpire"
                >
                  <v-container
                    grid-list-lg
                    class="pa-0 pt-3"
                    style="max-width: 750px"
                  >
                    <v-layout
                      row
                      wrap
                      class="py-3"
                      justify-space-between
                      align-center
                    >
                      <setting-header
                        class="pr-5"
                        style="min-width: 500px"
                        title="Validity (In hours)"
                        caption="validity time of invitation since expected at"
                      />
                      <v-text-field
                        v-model="invitesSettings.validity"
                        :rules="[v => !!v || 'validity is required']"
                        style="max-width:50px"
                        type="number"
                        min="1"
                        persistent-hint
                      />
                    </v-layout>
                  </v-container>
                </template>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import toggle from '@/components/common/Toggle';
import settingHeader from '@/components/common/SettingHeader';
import _get from 'lodash/get';
import { database } from '@/firebase';

export default {
  name: 'InvitesSettings',
  components: {
    toggle,
    'setting-header': settingHeader
  },
  data() {
    return {
      componentLoading: true,
      invitesSettings: {
        shouldFillRequiredFields: false,
        shouldSignAgreement: false,
        shouldTakePhoto: false,
        shouldExpire: false,
        validity: 24
      }
    };
  },
  computed: {
    inviteRef() {
      const lid = _get(this.$store.state.VMS, 'lid');
      // return null if the location ID is not yet set
      if (!lid) return null;

      return database.ref(`vms/${lid}/settings`);
    }
  },
  watch: {
    inviteRef: {
      handler(val) {
        if (!val) return;
        this.fetchSettings();
      },
      immediate: true
    },
    invitesSettings: {
      handler(val) {
        if (!val) return;
        this.inviteRef.child('invites').update(val);
      },
      deep: true
    }
  },
  created() {
    this.$store.commit('setToolbarTitle', { toolbarTitle: 'Invites Settings' });
  },
  methods: {
    fetchSettings() {
      this.inviteRef
        .child('invites')
        .once('value')
        .then(notificationSnapshot => {
          this.componentLoading = false;
          const notification = notificationSnapshot.val();
          if (!notification) return;
          this.invitesSettings = notification;
        });
    }
  }
};
</script>

